// Export PDF paths as constants
export const TermsPDF = "/assets/docs/terms.pdf";
export const PrivacyPDF = "/assets/docs/privacy.pdf";
